import { RematchDispatch, RematchRootState, init, Models } from "@rematch/core";

import common from "./models/common";
import filters from "./models/filters";
import items from "./models/items";
import UI from "./models/UI";
import history from "./models/history";

export interface RootModel extends Models<RootModel> {
  items: typeof items;
  filters: typeof filters;
  common: typeof common;
  UI: typeof UI;
  history: typeof history;
}

const rootModel: RootModel = { items, filters, common, UI, history };

export const store = init({
  models: rootModel,
  plugins: [],
  redux: {
    devtoolOptions: {},
    rootReducers: { RESET_APP: () => undefined }
  }
});

export type Store = typeof store;
export type Dispatch = RematchDispatch<RootModel>;
export type iRootState = RematchRootState<RootModel>;
